export enum ChatUserStatus {
    Active = 1,
    Inactive = 2,
    Offline = 3
}